import React from 'react'
import { Typography } from '@material-ui/core'
import useStyles from './styles'

export const CardField = (props) => {
  const { label, value, valueClassName } = props
  const classes = useStyles()

  return (
    <>
      <span className={classes.fieldLabel}>{label}:</span>
      <Typography className={`${classes.fieldValue} ${valueClassName || ''}`}>
        {value !== null && value !== undefined && value !== '' ? value : '-'}
      </Typography>
    </>
  )
}
